/*
 * Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import language from "@/stores/language";
import mediaQuery from "@/stores/media-queries";
import notifications from "@/stores/notifications";
import settings from "@/stores/settings";
import featured from "@/stores/featured";
import openingHours from "@/stores/opening-hours.js";

export default {
  language,
  mediaQuery,
  notifications,
  settings,
  featured,
  openingHours
};
